import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_engagement_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    customer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    running_no: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    alternate_code: fromDatatype.VarcharDatatypeInterface;
    engagement_type: fromDatatype.VarcharDatatypeInterface;
    department_code: fromDatatype.VarcharDatatypeInterface;
    engagement_category: fromDatatype.VarcharDatatypeInterface;
    date_start: fromDatatype.TimestampTzDatatypeInterface;
    date_end: fromDatatype.TimestampTzDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    engagement_status: fromDatatype.VarcharDatatypeInterface;
    billing_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    billing_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    customer_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    approval_setting_guid: fromDatatype.GuidDataFieldInterface;
    fiscal_year_logic: fromDatatype.VarcharDatatypeInterface;
    sub_branch_guid: fromDatatype.GuidDataFieldInterface;
    non_applicable_setting_json: fromDatatype.JsonDatatypeInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;

}

export class bl_aat_engagement_hdr_RowClass implements bl_aat_engagement_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    comp_guid: fromDatatype.GuidDataFieldInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    customer_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    running_no: fromDatatype.VarcharDatatypeInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    alternate_code: fromDatatype.VarcharDatatypeInterface;
    engagement_type: fromDatatype.VarcharDatatypeInterface;
    department_code: fromDatatype.VarcharDatatypeInterface;
    engagement_category: fromDatatype.VarcharDatatypeInterface;
    date_start: fromDatatype.TimestampTzDatatypeInterface;
    date_end: fromDatatype.TimestampTzDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    engagement_status: fromDatatype.VarcharDatatypeInterface;
    billing_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    billing_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    customer_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
    client_source: fromDatatype.VarcharDatatypeInterface;
    client_key: fromDatatype.VarcharDatatypeInterface;
    client_value: fromDatatype.VarcharDatatypeInterface;
    approval_setting_guid: fromDatatype.GuidDataFieldInterface;
    fiscal_year_logic: fromDatatype.VarcharDatatypeInterface;
    sub_branch_guid: fromDatatype.GuidDataFieldInterface;
    non_applicable_setting_json: fromDatatype.JsonDatatypeInterface;
    created_by_name: fromDatatype.VarcharDatatypeInterface;
    updated_by_name: fromDatatype.VarcharDatatypeInterface;
}
